"use client"

import type { NotificationContextType } from "@/modules/notification/types"

import { createContext } from "react"

export const NotificationContext = createContext<NotificationContextType | undefined>(undefined)
